import axios from 'axios';
export var toErrorMessage = function (err) {
    return err && err.response && err.response.data && err.response.data.message
        ? err.response.data.message
        : '';
};
export var extractApiErrorBody = function (err) {
    return err.response ? err.response.data : undefined;
};
export var extractApiErrorMessageFromAxiosErr = function (err) {
    var errorBody = extractApiErrorBody(err);
    if (errorBody && errorBody.message) {
        return errorBody.message;
    }
    return '';
};
export var isCancelled = function (err) { return err instanceof axios.Cancel; };
